import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, RequestOptions } from '@angular/http';
import { map, retry } from 'rxjs/operators';
import { LoadingController, ToastController, AlertController, Platform } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs'
import { Toast } from '@awesome-cordova-plugins/toast/ngx';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  link: any;
  data: any
  detail_data: any
  profile_data: any
  post_data: any
  img: any
  filter_data: any
  Ad_data: any
  edit_ad: any
  chat_status: any
  token: any
  setNoti: any
  newdata: any = [];
  postFood: any;
  supply: any;
  catadata: any = []
  cat_data: any =[];
  servicedata : any 
  cartid: any;
  constructor(private router: Router, public http: Http, public platform: Platform,
    public loadingController: LoadingController, public toasts: Toast,
    public toastController: ToastController) {
    this.link = 'https://lsm.com.pk/api/api.php'
  }
  toast_check(check) {
    if (this.platform.is('ios') || this.platform.is('android')) {
      this.toasts.showShortBottom(check).subscribe()
    }
    else {
      this.toast(check)
    }
  }
  set_device_token(token) {
    this.token = token
  }
  get_device_token() {
    return this.token
  }
  // set_noti_routing(token) {
  //   this.token = token
  // }
  // get_device_token() {
  //   return this.token
  // }
  get_cat(parent_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'med_categories');
    postData.append('parent_id', parent_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  ad_view(ad_id,user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'ad_views');
    postData.append('ad_id', ad_id)
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  sub_cat(parent_id,sub_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'items');
    postData.append('cat_id', parent_id)
    postData.append('subcat_id', sub_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  payment_detail(method_name, bank_name, acc_title, acc_no, user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'payment_account_detail');
    postData.append('method_type', method_name)
    postData.append('bank_name', bank_name)
    postData.append('acc_title', acc_title)
    postData.append('acc_no', acc_no)
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  payment_detail_update(method_name, bank_name, acc_title, acc_no, user_id, id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'update_data');
    postData.append('table_name', 'payment_account_detail');
    postData.append('method_type', method_name)
    postData.append('bank_name', bank_name)
    postData.append('acc_title', acc_title)
    postData.append('acc_no', acc_no)
    postData.append('user_id', user_id)
    postData.append('id', id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  checkout_goat(user_id, name, phone, delivery_address, price, total): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'goat_sadqa');
    postData.append('name', name)
    postData.append('phone', phone)
    postData.append('delivery_address', delivery_address)
    postData.append('total', total)
    postData.append('user_id', user_id)
    postData.append('price', price)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  sadqa_detail(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'goat_sadqa');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  payment_datail_get(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'payment_account_detail');
    postData.append('user_id', user_id)

    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  login(email, password): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'login');
    postData.append('email', email)
    postData.append('password', password)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  ad_image(image): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'ad_images');
    postData.append('image', image)
    // postData.append('password', password)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }



  signup(username, email, phone, password, confirm_password, state, city): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'register');
    postData.append('username', username)
    postData.append('email', email)
    postData.append('phone', phone)
    postData.append('password', password)
    postData.append('confirm_password', confirm_password)
    postData.append('state', state)
    postData.append('city', city)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  change_password(password, user_id, old_password): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'change_password');
    postData.append('password', password);
    postData.append('old_password', old_password);
    postData.append('user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }


  personal_info(username, email, state, city, password, confirm_password, phone): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'personal_info');
    postData.append('username', username)
    postData.append('email', email)
    postData.append('password', password)
    postData.append('confirm_password', confirm_password)
    postData.append('state', state)
    postData.append('city', city)
    postData.append('phone', phone)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  forgot_password(email): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'forgot_password');
    postData.append('phone', email)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  seller_posts(id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('user_id', id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_categories(): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_categories');
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_categories_(id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_categories');
    postData.append('id', id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }


  setcartid(data){
    this.cartid = data
  }
  getcartid(){
    return this.cartid

  }


  set_catdata(data) {
    this.catadata = data
  }

  get_catdata() {
    return this.catadata
  }
  set_catsid(data) {
    this.data = data
  }
  get_catsid() {
    return this.data
  }
  profile(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'profile');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  chk_msg_count(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_unseen_msg_count');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  setProfileData(data) {
    this.profile_data = data
  }
  getProfileData() {
    return this.profile_data
  }
  update_profile(user_id, username, phone, email, state, city): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'update_profile');
    postData.append('user_id', user_id)
    postData.append('username', username)
    postData.append('phone', phone)
    postData.append('email', email)
    postData.append('state', state)
    postData.append('city', city)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  update_img(user_id, image): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'register_img');
    postData.append('user_id', user_id)
    postData.append('img', image)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  cart_history(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'cart')
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  just_deivery_order(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'just_delivery')
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  cart_history_data(user_id,id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'cart')
    postData.append('user_id', user_id)
    postData.append('id', id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  add_sale(price, title, description, location, user_id, city, cat_id, subcat_id, images, video,avail_qty,item_type  ): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'ads');
    postData.append('price', price);
    postData.append('title', title);
    postData.append('description', description);
    postData.append('address', location);
    postData.append('user_id', user_id);
    postData.append('city', city);
    postData.append('cat_id', cat_id);
    postData.append('subcat_id', subcat_id);
    postData.append('image_ref', images);
    postData.append('video_file', video);
    postData.append('avail_qty', avail_qty);
    postData.append('item_type', item_type);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  checkout_cart(invoice_no, items, delivery_fee, total, delivery_address, full_name, user_id,pay_type): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'cart');
    postData.append('invoice_no', invoice_no);
    postData.append('items', items);
    postData.append('delivery_fee', delivery_fee);
    postData.append('total', total);
    postData.append('delivery_address', delivery_address);
    postData.append('full_name', full_name);
    postData.append('user_id', user_id);
    postData.append('pay_type', pay_type);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  cart_order_detail(id):Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'cart_order_detail');
    postData.append('id', id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  update_sale(price, title, description, location, images, user_id, id, video,avail_qty,item_type): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'update_data');
    postData.append('table_name', 'ads');
    postData.append('price', price);
    postData.append('title', title);
    postData.append('description', description);
    postData.append('address', location);
    postData.append('user_id', user_id);
    postData.append('id', id);
    postData.append('image_ref', images);
    postData.append('video_file', video);
    postData.append('avail_qty', avail_qty);
    postData.append('item_type', item_type);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  mark_as_sold(ad_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'update_data');
    postData.append('table_name', 'ads');
    postData.append('id', ad_id);
    postData.append('status', '2');
    postData.append('user_id', window.localStorage.getItem('user_id_lsm'))
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  ads(last_id, search, selected_cat, featured,rand): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('cat_id', selected_cat)
    postData.append('featured', featured)
    postData.append('rand', rand)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  feature_ads(last_id, search, selected_cat, featured, user_id,rand): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'my_featured_ads');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  pet_adopt(last_id, search, selected_cat, featured): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('category_id', selected_cat)
    postData.append('featured', featured)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  search_ads(last_id, search, selected_cat, featured, min_price, max_price, city): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('cat_id', selected_cat)
    postData.append('featured', featured)
    postData.append('min_price', min_price)
    postData.append('max_price', max_price)
    postData.append('city', city)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  search_items(last_id, search, selected_cat, featured, min_price, max_price, city): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'items')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('cat_id', selected_cat)
    postData.append('featured', featured)
    postData.append('min_price', min_price)
    postData.append('max_price', max_price)
    postData.append('city', city)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  notifications(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'notifications')
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  setPostDetail(data) {
    this.post_data = data
  }
  ads_cat(last_id, search, cat_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads')
    postData.append('last_id', '')
    postData.append('search', '')
    postData.append('cat_id', cat_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  getPostDetail() {
    return this.post_data
  }
  setPic(data) {
    this.img = data
  }
  getPic() {
    return this.img
  }
  setAdData(data) {
    this.Ad_data = data
  }
  getAdData() {
    return this.Ad_data
  }
  setChatStatus(chat) {
    this.chat_status = chat
  }
  getChatStatus() {
    return this.chat_status
  }
  like_dislike(user_id, ads_id, status): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'like_dislike');
    postData.append('user_id', user_id);
    postData.append('ads_id', ads_id);
    postData.append('status', status);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  like_dislike_item(user_id, ads_id, status): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'like_dislike_item');
    postData.append('user_id', user_id);
    postData.append('item_id', ads_id);
    postData.append('status', status);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_unseen(u_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_unseen');
    postData.append('u_id', u_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  chat_noti_seen(u_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'chat_noti_seen');
    postData.append('u_id', u_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  seller_ads(seller_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads');
    postData.append('user_id', seller_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  seller_ads_more(seller_id, last_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ads');
    postData.append('user_id', seller_id);
    postData.append('last_id', last_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  chat_list(u_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'chat_list');
    postData.append('u_id', u_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  my_ads(user_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'my_ads');
    postData.append('user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  // my_ads_feature(user_id,featured): Observable<[]> {
  //   let postData = new FormData();
  //   postData.append('type', 'get_data');
  //   postData.append('table_name', 'ads')
  //   postData.append('user_id', user_id);
  //   postData.append('featured', featured)
  //   return this.http.post(this.link, postData).pipe(map(res => res.json()))
  // }
  get_favourite(user_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_favourite');
    postData.append('user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_favourite_item(user_id):Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_favourite_item');
    postData.append('user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  msg_seen(user_id, to_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'msg_seen');
    postData.append('user_id', user_id);
    postData.append('to_id', to_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  delete_data(user_id, id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'delete_data');
    postData.append('table_name', 'ads');
    postData.append('user_id', user_id);
    postData.append('id', id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  setEditAd(ad) {
    this.edit_ad = ad
  }
  getEditAds() {
    return this.edit_ad
  }
  setcat_data(data){
    this.cat_data = data
  }
  getcat_data(){
    return this.cat_data
  }
  login_phone(phone, hash, device_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'send_otp');
    postData.append('phone', phone);
    postData.append('hash', hash)
    postData.append('device_id', device_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  resend_otp(phone, hash,device_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'send_otp');
    postData.append('phone', phone)
    postData.append('hash', hash)
    postData.append('device_id', device_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  delete_acc(user_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'delete_account');
    postData.append('user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_data(id, ads): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('id', id);
    postData.append('table_name', ads);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_data_detail(id, ads, user_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('id', id);
    postData.append('table_name', ads);
    postData.append('like_user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_food(cat_id, items,sub_cat_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'items');
    postData.append('cat_id', cat_id);
    postData.append('sub_cat_id', sub_cat_id);

    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_fooddetail(id, cat_id,user_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'items');
    postData.append('cat_id', cat_id);
    postData.append('id', id);
    postData.append('like_user_id', user_id);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_supply(last_id, id, cat_id,subcat_id): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'items');
    postData.append('cat_id', cat_id);
    postData.append('id', id);
    postData.append('last_id', last_id)
    postData.append('subcat_id', subcat_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  set_data(data) {
    this.newdata = data
  }

  get_newdata() {
    return this.newdata
  }
  setPostproductDetail(supplies) {
    this.post_data = supplies
  }
  getPostproductDetail() {
    return this.post_data
  }

  setservices(router_data){
    this.servicedata = router_data
   
  }
  
  getservices(){
    return this.servicedata
   
  }

  notification(user_id, devicePlatform, deviceRid, deviceModel): Observable<[]> {
    let postData = new FormData();
    postData.append('type', 'update_noti');
    postData.append('user_id', user_id);
    postData.append('devicePlatform', devicePlatform);
    postData.append('deviceModel', deviceModel);
    postData.append('deviceRid', deviceRid);
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }



  post_offer(post_type, title, des, cat, subcat, tp, unit, country, city, user_id, images): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'offers')
    postData.append('post_type', post_type)
    postData.append('user_id', user_id)
    postData.append('title', title)
    postData.append('description', des)
    postData.append('category', cat)
    postData.append('subcategory', subcat)
    postData.append('tp', tp)
    postData.append('unit', unit)
    postData.append('country', country)
    postData.append('city', city)
    postData.append('image', images)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  post_demand(post_type, title, des, cat, subcat, country, city, user_id, images): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'demands')
    postData.append('post_type', post_type)
    postData.append('user_id', user_id)
    postData.append('title', title)
    postData.append('description', des)
    postData.append('category', cat)
    postData.append('subcategory', subcat)
    postData.append('country', country)
    postData.append('city', city)
    postData.append('image', images)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_offers(last_id, search, user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'offers')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_demand(last_id, search, user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'demands')
    postData.append('last_id', last_id)
    postData.append('search', search)
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  personal_info_img(user_id, img): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'register_img');
    postData.append('user_id', user_id)
    postData.append('img', img)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  update_profile_pic(user_id, img): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'register_img');
    postData.append('user_id', user_id)
    postData.append('img', img)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  my_dashboard(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'dashboard');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  checkout(full_name, phone, city, location, price, user_id, ads_id,delivery_fee,qty): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'orders');
    postData.append('user_id', user_id)
    postData.append('name', full_name)
    postData.append('phone', phone)
    postData.append('city', city)
    postData.append('address', location)
    postData.append('ad_id', ads_id)
    postData.append('method_id', '0')
    postData.append('amount', price)
    postData.append('delivery_charges', delivery_fee)
    postData.append('qty', qty)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  checkout_service(full_name, phone, city, location,user_id, ads_id, price,delivery_fee,qty): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'orders');
    postData.append('user_id', user_id)
    postData.append('name', full_name)
    postData.append('phone', phone)
    postData.append('city', city)
    postData.append('address', location)
    postData.append('ad_id', ads_id)
    postData.append('method_id', '0')
    postData.append('amount', price)
    postData.append('delivery_charges', delivery_fee)
    postData.append('qty', qty)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }



  setDetailData(data) {
    this.detail_data = data
  }
  getDetailData() {
    return this.detail_data
  }
  
  setFilter(data) {
    this.filter_data = data
  }
  getFilter() {
    return this.filter_data
  }
  reivew(user_id, order_id, rating, review, ad_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'reviews');
    postData.append('user_id', user_id);
    postData.append('order_id', order_id);
    postData.append('rating', rating);
    postData.append('detail', review);
    postData.append('ad_id', ad_id);

    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_order(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'orders');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  get_rcv_order(seller_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'orders');
    postData.append('seller_id', seller_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  order_noti_detail(id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'order_detail');
    // postData.append('table_name', 'orders');
    postData.append('id', id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  order_history(order_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'order_statuses');
    postData.append('order_id', order_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  buyer_order_pictures(order_id, user_id, images, status, detail): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'order_statuses');
    postData.append('order_id', order_id)
    postData.append('user_id', user_id)
    postData.append('status', status)
    postData.append('details', detail)
    postData.append('image', images)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  dispute(order_id, user_id, message): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'disputes');
    postData.append('order_id', order_id);
    postData.append('user_id', user_id)
    postData.append('message', message)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  trans(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'transactions');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  getOrderDetail(order_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'orders');
    postData.append('id', order_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  check_noti(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'noti_check');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  noti_seen(user_id): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'noti_seen');
    postData.append('user_id', user_id)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  setComingFrom(data) {
    this.setNoti = data
  }
  getComingFrom() {
    return this.setNoti
  }
  reportAd(user_id, ad_id, contentCheck, userCheck, detail): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'reports')
    postData.append('user_id', user_id)
    postData.append('offer_id', ad_id)
    postData.append('report_type', contentCheck)
    postData.append('reason', userCheck)
    postData.append('detail', detail)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  upload_video(video): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'upload_video');
    postData.append('video', video)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  help(user_id,message): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'help');
    postData.append('user_id', user_id);
    postData.append('message', message)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }
  just_deivery(user_id,drop_city,drop_phone,pick_city,pick_phone,delivery_fee,quantity,delivery_type,drop_state,pick_state,bird_name): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'add_data');
    postData.append('table_name', 'just_delivery');
    postData.append('user_id', user_id);
    postData.append('drop_city', drop_city)
    postData.append('drop_phone', drop_phone)
    postData.append('pick_city', pick_city)
    postData.append('pick_phone', pick_phone)
    postData.append('delivery_fee', delivery_fee)
    postData.append('quantity', quantity)
    postData.append('delivery_type', delivery_type)
    postData.append('drop_state', drop_state)
    postData.append('pick_state', pick_state)
    postData.append('bird_name', bird_name)
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  get_fq(): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'faq')
    return this.http.post(this.link, postData).pipe(map(res => res.json()))

  }


  get_dna_rates(): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'dna_rates');
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }

  ring_rates(): Observable<any[]> {
    let postData = new FormData();
    postData.append('type', 'get_data');
    postData.append('table_name', 'ring_rates');
    return this.http.post(this.link, postData).pipe(map(res => res.json()))
  }


  payment(url,data): Observable<any[]> {
    let postData = new FormData();
    postData.append('data', data)
    return this.http.post(url, postData).pipe(map(res => res.json()))

  }
  async toast(message) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      cssClass: 'toast',
      animated: true,
      color: 'dark',
      mode: 'ios',
    });
    toast.present();
  }
  checkUrdu(description) {
    var arregex = /[\u0600-\u06FF]/;
    var test = arregex.test(description);
    return test
  }

  
}
